import { ReactElement } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../../hooks/useUser';

interface Props { permission: string; children: ReactElement; }

const ProtectedRoute = ({ permission, children }: Props) => {
    const user = useUser();
    const location = useLocation();
    if (!user.authReady) return <Box minHeight="60vh" display="grid" sx={{ placeItems: 'center' }}><CircularProgress /></Box>;
    if (!user.currentUser) return <Navigate to="/logowanie" replace state={{ from: location.pathname }} />;
    if (user.currentUser.mustChangePassword) return <Navigate to="/zmien-haslo" replace />;
    if (!user.hasPermission(permission)) {
        return <Box minHeight="60vh" display="grid" sx={{ placeItems: 'center', textAlign: 'center', p: 3 }}><Typography variant="h5">Nie masz uprawnienia do tej strony</Typography></Box>;
    }
    return children;
};

export default ProtectedRoute;
